"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyLoad = ({ url_prefix, successAction, show_dialog, set_show_dialog, processing, setProcessing, failure, setFailure, not_started, setNotStarted }) => {
    const [result, setResult] = (0, react_1.useState)('');
    const [value, setValue] = (0, react_1.useState)([1, 2]);
    const reset = () => {
        setProcessing(false);
        setFailure(false);
        setNotStarted(true);
    };
    const handleChange = (evt) => {
        if (value.includes(+evt.target.value)) {
            value.splice(value.indexOf(evt.target.value));
        }
        else {
            value.push(+evt.target.value);
        }
        setValue([...value]);
    };
    const infos = result !== undefined ? result.split('\n') : [];
    const success_status = 'Chargement terminée';
    const failure_status = 'Echec du chargement';
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_dialog, onHide: () => set_show_dialog(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Chargement du fichier ")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 5 }),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, not_started ? (react_1.default.createElement(react_1.default.Fragment, null)) :
                            processing ? (react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning" },
                                react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                                " En traitement...")) : (failure ?
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: reset }, failure_status) :
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: () => {
                                        successAction();
                                        set_show_dialog(false);
                                    } }, success_status))),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 5 })),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement("h3", { style: { textAlign: 'center' } }, "Terminal"))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 1, variant: value.includes(1) ? 'info' : 'light' }, "Infos"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 2, variant: value.includes(2) ? 'danger' : 'light' }, "Erreurs"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 3, variant: value.includes(3) ? 'warning' : 'light' }, "Debug")))),
                    processing ? (react_1.default.createElement(Counter, { url_prefix: url_prefix, finishReconciliation: () => {
                            setProcessing(false);
                            setFailure(false);
                            //setNotStarted(true)
                        }, value: value, result: result, setResult: setResult })) : (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map((info) => (value.includes(2) && info.includes('ERROR') ?
                            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
                            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                                : value.includes(3) && (info.includes('DEBUG')) ?
                                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null)))))))))));
};
const Counter = ({ url_prefix, finishReconciliation, value, result, setResult }) => {
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            //const path = window.location.href
            let root = window.location.href;
            if (root.includes('sankey-diagrams') && url_prefix !== '') {
                root = root.replace('sankey-diagrams/', '');
            }
            //const url = root + 'load_process'
            const url = root + 'load_process';
            const fetchData = {
                method: 'POST',
                body: ''
            };
            //console.log('fetch')
            fetch(url, fetchData).then(function (response) {
                //console.log('response')
                if (response.ok) {
                    //console.log('response ok')
                    response.json().then(function (data) {
                        //console.log('setResult')
                        setResult(data.output);
                    });
                }
            });
        }, 5000);
        return () => clearInterval(interval);
    });
    //let {value, result} = parent
    const infos = result !== undefined ? result.split('\n') : [];
    if (infos.length > 2) {
        //const info = infos[infos.length-2]
        if (result.includes('FINISHED')) {
            //console.log('finished')
            finishReconciliation(false);
        }
        else if (result.includes('FAILED')) {
            finishReconciliation(true);
        }
    }
    else {
        //console.log('else')
    }
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map(info => (value.includes(2) && info.includes('ERROR') ?
            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                : value.includes(3) && (info.includes('DEBUG')) ?
                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null))))));
};
exports.default = SankeyLoad;
